import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/differenceInCalendarWeeks/index.js';

var require$$38 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$38 as default };
